exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bdr-tabs[data-v-630d95ee]{margin-bottom:25px}.bdr-tabs .card-body[data-v-630d95ee]{padding:1.25rem 0}.order-service-menu[data-v-630d95ee]{font-weight:700;border-bottom:2px solid #ccc;cursor:pointer;padding-bottom:6px;padding-left:4px;padding-right:4px;display:inline-block;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;transition:all .2s ease}.order-service-menu[data-v-630d95ee]:hover{color:#ea7b27}.order-service-menu__active[data-v-630d95ee]{color:#ea7b27;border-bottom:2px solid #ea7b27}", ""]);

// exports
